import get from 'lodash/get';
import {
  validationObject,
  validateRequired,
  validateString,
  validateArrayRequirement,
} from 'utils/validations';
import { ZoneInfo } from 'utils/constants/informationText';
import {
  RISK_CONSEQUENCE_OPTIONS,
  RISK_LIKELIHOOD_OPTIONS,
} from 'utils/constants/risks';
import { getRiskLevelByValue } from 'utils/helper/zone';
import { LOCATION_MODE } from 'utils/constants/Map';
import { getEventCategoryByServices } from 'containers/Pages/Events/Layouts';
import { optionalFormField } from 'utils/methods/helpers';
import { USER_FIELDS } from 'utils/formFields/user';

export const initialValues = data => {
  const displayedValues = {
    ...data.generalInfo,
    ...data.detailedInfo,
    ...data.others,
  };

  const initial = {};
  Object.entries(displayedValues).forEach(([key, value]) => {
    initial[key] = value.idValue ? value.idValue : value.value;
  });

  return {
    ...initial,
    paths: get(initial, 'boundary.boundary', []),
  };
};

export const validationSchema = validationObject({
  name: validateString(30, true),
  hazard: validateRequired(),
  consequence: validateRequired(),
  likelihood: validateRequired(),
  paths: validateArrayRequirement(3),
  locations: validateRequired(),
});

export const initialState = {
  name: undefined,
  hazard: undefined,
  consequence: undefined,
  likelihood: undefined,
  paths: undefined,
  locations: undefined,
};

export const generalSection = (userAssignedDepartments, services = []) => [
  {
    field: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    size: 'half',
    placeholder: 'Enter a zone name',
    info: ZoneInfo.name,
  },
  {
    field: 'hazard',
    type: 'select',
    required: true,
    size: 'half',
    options: getEventCategoryByServices(services),
    info: ZoneInfo.hazard,
  },
  {
    field: 'consequence',
    type: 'select',
    required: true,
    size: 'third',
    options: RISK_CONSEQUENCE_OPTIONS,
    info: ZoneInfo.consequence,
  },
  {
    field: 'likelihood',
    type: 'select',
    required: true,
    size: 'third',
    options: RISK_LIKELIHOOD_OPTIONS,
    info: ZoneInfo.likelihood,
  },
  {
    field: 'riskLevel',
    type: 'text-translated',
    required: false,
    size: 'third',
    placeholder: 'Select consequence and likelihood',
    disabled: true,
    info: ZoneInfo.riskLevel,
  },
  ...optionalFormField({
    showWhen: userAssignedDepartments.length > 0,
    field: USER_FIELDS.departments({ userAssignedDepartments }),
  }),
];

export const detailedSection = riskLevel => [
  {
    field: 'locations',
    required: true,
    label: 'Zone Boundary',
    type: 'polygon-creator',
    eventType: getRiskLevelByValue(riskLevel),
    secondaryValue: 'paths',
    additionalPolygonMode: LOCATION_MODE.HIGH_DETAIL,
  },
  {
    field: 'descriptionIncludingRiskContext',
    type: 'textArea',
    maxLength: 1000,
    placeholder: 'placeholder_description_risk_context',
  },
  {
    field: 'recommendation',
    type: 'textArea',
    maxLength: 250,
    placeholder: 'Enter a default recommendation',
    info: ZoneInfo.recommendation,
  },
];
